import styled from 'styled-components';

export const StyledImage = styled.img`
  height: 16px;
  vertical-align: middle;
`;
